module.exports = __webpack_public_path__ + "static/media/icon-request-edit.b220fa44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-request-edit.svg
// module id = 441
// module chunks = 11